import ko from 'knockout';
import _ from 'underscore';

export default class {
  constructor({
    tabs = [],
  } = {}) {
    this.selectedPanel = ko.observable();
    this.tabGroups = _.map(tabs, (tab) => {
      return _.map(tab, ({ title }, name) => {
        if (!this.selectedPanel()) {
          this.selectedPanel(name);
        }

        return {
          name,
          title,
        };
      });
    });
  }

  isTabGroupVisible(tabGroup) {
    return _.find(tabGroup, {
      name: this.selectedPanel(),
    });
  }
}
